import { ETabsVariant, Tabs } from '@/components/common/Hero/Tabs';

export const HeroTabs = () => {
  return (
    <div className="pt-3 pb-5 lg:py-3">
      <Tabs tabVariant={ETabsVariant.Rentals} />
    </div>
  );
};
